<div class="h-[100%]">
  <div class="w-full h-full z-20">
    <ng-container *ngIf="mode === 1">
      <ng-container *ngIf="currentStep === 4">
        <div id="section-project-workpackages" class="section-color">
          <app-workpackages
            [category]="selectedCategory"
            [originalCollection]="originalCollection"
            [collectionL]="collectionL"
            [collectionR]="collectionR"
            [selectedParentWP]="selectedParentWP"
            [isEdit]="isEdit"
          ></app-workpackages>
        </div>
        <div class="section-color" *ngIf="selectedSubCategory === 'Manual'">
          <app-manual-generated></app-manual-generated>
        </div>
      </ng-container>
      <ng-container *ngIf="currentStep === 5">
        <div class="section-color" id="cost">
          <app-cost-estimation
            id="section-project-costestimations"
            (returnBack)="callWorkPackages()"
          ></app-cost-estimation>
        </div>
      </ng-container>
      <ng-container *ngIf="currentStep === 6">
        <div class="section-color" id="raci">
          <app-racimatrix
            id="section-project-racimatrix"
            (dataChange)="onDataChangeFromSubChild($event)"
          ></app-racimatrix>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 7">
        <div class="section-color h-[100%]" id="risk">
          <app-risk-assessment
            id="section-project-riskassessment"
            [progress]="progress"
          ></app-risk-assessment>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="mode === 2">
      <app-stage2viewmode></app-stage2viewmode>
    </ng-container>
  </div>
</div>

<ng-template #toggleButton>
  <div class="sticky-switch-container">
    <div
      class="mode-toggle"
      [class.edit-mode]="isEditMode"
      (click)="toggleMode()"
    >
      <div class="toggle-option view-option" [class.active]="!isEditMode">
        <span>View</span>
      </div>
      <div
        (click)="clickEditProjectBrief()"
        class="toggle-option edit-option"
        [class.active]="isEditMode"
      >
        <span>Edit</span>
      </div>
    </div>
  </div>
</ng-template>
